<template>
  <b-dropdown-item
    :to="to"
    :active="active"
    :disabled="disabled"
    link-class="builder-nav-font-size nav-link"
    variant="primary"
  >
    <font-awesome-icon
      :icon="icon"
      :size="iconSize"
      class="fa-w-20 mr-2"
    />{{ title }}
  </b-dropdown-item>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  sidepanel: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  disabled: Boolean,
  icon: {
    type: [String, Array],
    default: '',
  },
  iconSize: {
    type: String,
    default: 'lg',
  },
  currentSidepanelParam: {
    type: String,
    default: null,
  },
  mainpanel: {
    type: String,
    default: 'public',
  },
}

@Component
export default class BuilderNavItem extends Vue.extend({ props }) {
  get active () {
    return this.sidepanel === this.currentSidepanelParam
  }

  get to () {
    return {
      params: {
        sidepanel: this.sidepanel,
        mainpanel: this.mainpanel,
      },
    }
  }
}
</script>
